import React from 'react';
import './info.scss';
import Photo from '../Photo';
import Edu from '../Edu';
import Intro from '../Intro';
import Exp from '../Exp';
import Adv from '../Adv';

const Info = ({ lang }) => {
  return (
    <div className='Info'>
      <div className='part'>
        <Photo />
        <Intro lang={lang} />
      </div>
      <Exp lang={lang} />
      <Edu lang={lang} />
      <Adv lang={lang} />
    </div>
  );
};

export default Info;
